// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3NJB-","Success":"Button_Success__19N3w","Danger":"Button_Danger__1WHlC"};